(() => {
  'use strict';
  // PATAGONIA — parcours d'achat 28-10, deuxième couche.
  // 1. Fiche produit : barre d'achat collante (mobile uniquement, réversible).
  // 2. Page abonnement : les avis au moment du choix (mobile uniquement).
  // 3. Règle de livraison dite en clair, partout : nos tarifs sont ceux du Point Relais
  //    Mondial Relay, un autre transporteur reste possible et l'écart est à la charge
  //    du client le cas échéant.
  // 4. Tiroir panier : total et bouton de paiement toujours visibles en bas.
  // 5. Liens : on retire le paramètre d'aperçu de thème quand on n'est pas en aperçu.
  const mobile = window.matchMedia('(max-width: 749px)');
  const NBSP = String.fromCharCode(160);
  const clean = s => String(s || '').split(NBSP).join(' ').replace(/\s+/g, ' ').trim();

  const RULE = 'Nos frais de livraison sont calculés sur le Point Relais Mondial Relay.';
  const GRID = 'Point Relais Mondial Relay : 2,90 € jusqu’à 1,25 kg de colis, offerte au-delà. ' +
    'À domicile avec Colissimo : 5,00 € jusqu’à 1,25 kg, 2,90 € jusqu’à 1,80 kg, offerte au-delà. ' +
    'Le poids retenu est celui du colis, emballage compris. ' +
    'Vous restez libre de choisir un autre transporteur, l’écart sera à votre charge le cas échéant.';
  const RELAY_HELP = 'Référence Mondial Relay, en France métropolitaine. ' +
    'Un autre transporteur peut entraîner un supplément. ' +
    'Vous renseignerez votre adresse au paiement, puis vous choisirez votre point relais à l’étape suivante.';

  /* 1. Barre d'achat collante sur la fiche produit */
  let bar = null;
  function atcButton() {
    return [...document.querySelectorAll('button[name=add]')].find(b => b.offsetParent !== null);
  }
  function buildBar() {
    const b = document.createElement('div');
    b.className = 'pcp28-bar';
    b.hidden = true;
    b.innerHTML = '<div class="pcp28-bar__txt"><strong></strong><span></span></div>' +
      '<button type="button" class="pcp28-bar__btn">Ajouter au panier</button>';
    b.querySelector('.pcp28-bar__btn').addEventListener('click', () => {
      const a = atcButton();
      if (a) a.click();
    });
    document.body.appendChild(b);
    return b;
  }
  function barText() {
    const h1 = document.querySelector('#MainContent h1');
    const price = document.querySelector('#MainContent .price__regular .price-item--regular') ||
      document.querySelector('#MainContent .price-item--regular');
    const fmt = [...document.querySelectorAll('input[name=Format]')].find(i => i.checked);
    const mou = [...document.querySelectorAll('input[name=Mouture]')].find(i => i.checked);
    bar.querySelector('strong').textContent = h1 ? clean(h1.textContent) : 'Votre café';
    const bits = [];
    if (price) bits.push(clean(price.textContent));
    if (fmt) bits.push(clean(fmt.value));
    if (mou) bits.push(clean(mou.value));
    bar.querySelector('span').textContent = bits.join(' · ');
  }
  function syncBar() {
    const atc = atcButton();
    if (!mobile.matches || !atc) {
      if (bar) bar.hidden = true;
      document.body.classList.remove('pcp28-has-bar');
      return;
    }
    if (!bar) bar = buildBar();
    const r = atc.getBoundingClientRect();
    const away = r.bottom < 56 || r.top > window.innerHeight - 40;
    bar.hidden = !away;
    document.body.classList.toggle('pcp28-has-bar', away);
    if (away) barText();
  }

  /* 2. La règle de livraison, dite de la même façon partout */
  function wording() {
    document.querySelectorAll('.pcf-contribution').forEach(p => {
      if (p.dataset.pcpWorded === '1') return;
      const t = clean(p.textContent);
      // La gratuité se suffit à elle-même, on n'y touche pas.
      if (/offerte par Patagonia/i.test(t)) return;
      p.dataset.pcpWorded = '1';
      p.textContent = RULE;
    });
    document.querySelectorAll('.pcf-shipping-detail').forEach(det => {
      if (det.dataset.pcpWorded === '1') return;
      det.dataset.pcpWorded = '1';
      const s = document.createElement('summary');
      s.textContent = 'Comment la livraison est calculée';
      const p = document.createElement('p');
      p.textContent = GRID;
      det.textContent = '';
      det.append(s, p);
    });
    document.querySelectorAll('[data-pcf-delivery-note]').forEach(n => {
      if (/reste du transport en charge/i.test(n.textContent)) n.textContent = RULE;
    });
    // « Le relais se choisit après le paiement » inquiète plus qu'il ne rassure.
    document.querySelectorAll('.pcc-helper').forEach(p => {
      if (p.dataset.pcpWorded === '1') return;
      if (!/le relais se choisit après le paiement/i.test(p.textContent)) return;
      p.dataset.pcpWorded = '1';
      p.textContent = RELAY_HELP;
    });
  }

  /* 3. Tiroir panier : total et bouton de paiement toujours sous les yeux */
  function dock() {
    const drawer = document.getElementById('pcf-cart-drawer');
    if (!drawer) return;
    const box = drawer.querySelector('.pcf-buybox');
    if (!box) return;
    const kids = [...box.children];
    const total = kids.find(e => e.classList.contains('pcf-total'));
    const cta = kids.find(e => (e.tagName === 'A' || e.tagName === 'BUTTON') &&
      /passer au paiement|valider mon panier/i.test(e.textContent));
    const keep = kids.find(e => e.matches('[data-pcf-cart-continue].pcf-keep-shopping'));
    if (!total || !cta) return;
    const note = (cta.nextElementSibling && cta.nextElementSibling.classList.contains('pcf-small'))
      ? cta.nextElementSibling : null;
    const keepNote = keep && keep.nextElementSibling &&
      keep.nextElementSibling.classList.contains('pcf-keep-shopping-note')
      ? keep.nextElementSibling : null;
    let d = box.querySelector('.pcp28-dock');
    if (!d) {
      d = document.createElement('div');
      d.className = 'pcp28-dock';
    }
    let actions = d.querySelector('.pcp28-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'pcp28-actions';
    }
    box.appendChild(d);
    d.append(total, actions);
    // Les deux décisions vont ENSEMBLE dans le socle fixe, sans texte entre elles.
    if (keep) actions.append(keep);
    actions.append(cta);
    if (keepNote) d.append(keepNote);
    if (note) d.append(note);
  }

  /* 4. Page abonnement : les avis au moment du choix */
  let proofHome = null;
  function abonnementProof() {
    const proof = document.querySelector('.pcp28-proof--page');
    if (!proof) return;
    if (!mobile.matches) {
      if (proofHome) { proofHome.replaceWith(proof); proofHome = null; }
      return;
    }
    const calc = document.querySelector('.pcc-calculator');
    if (calc && !proofHome) {
      proofHome = document.createComment('pcp28-proof');
      proof.before(proofHome);
      calc.before(proof);
    }
  }

  /* 5. Liens d'aperçu de thème laissés dans le code */
  function previewing() {
    try {
      const el = document.getElementById('pcf-config');
      return Boolean(el && JSON.parse(el.textContent).preview === true);
    } catch (e) { return false; }
  }
  function cleanLinks() {
    if (previewing()) return;
    document.querySelectorAll('a[href*="preview_theme_id"]').forEach(a => {
      try {
        const u = new URL(a.href, location.origin);
        u.searchParams.delete('preview_theme_id');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  let t1;
  const soon = () => {
    clearTimeout(t1);
    t1 = setTimeout(() => { wording(); dock(); abonnementProof(); cleanLinks(); }, 200);
  };
  function watch(el, flag) {
    if (!el || el.dataset[flag] === '1') return;
    el.dataset[flag] = '1';
    new MutationObserver(soon).observe(el, { childList: true, subtree: true });
  }
  function init() {
    syncBar();
    wording();
    dock();
    abonnementProof();
    cleanLinks();
    watch(document.querySelector('[data-pcf-cart]'), 'pcpCartWatched');
    watch(document.getElementById('pcf-cart-drawer'), 'pcpDrawerWatched');
    watch(document.querySelector('pc-club-explorer'), 'pcpClubWatched');
  }
  window.addEventListener('scroll', syncBar, { passive: true });
  window.addEventListener('resize', syncBar, { passive: true });
  document.addEventListener('change', () => { syncBar(); soon(); });
  document.addEventListener('input', soon);
  document.addEventListener('pcf:cart-updated', soon);
  mobile.addEventListener('change', () => { syncBar(); abonnementProof(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();